import script from "./sideNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./sideNavigation.vue?vue&type=script&setup=true&lang=js"

import "./sideNavigation.vue?vue&type=style&index=0&id=0ed56406&scoped=true&lang=css"

import exportComponent from "D:\\WorkJob\\SmartCarRace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ed56406"]])

export default __exports__